import { render } from "./wPassword.vue?vue&type=template&id=3366ebc8&ts=true"
import script from "./wPassword.vue?vue&type=script&lang=ts"
export * from "./wPassword.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__